function RemainingTime(history) {
    const currentDate = new Date();
    const start = new Date(history);

    const duration_milliseconds = currentDate.getTime() - start.getTime();
    const duration_seconds = Math.round(duration_milliseconds / 1000);
    const duration_minutes = Math.round(duration_seconds / 60);
    const duration_hours = Math.round(duration_minutes / 60);
    const duration_days = Math.round(duration_hours / 24);
    const duration_months = Math.round(duration_days / 30);
    const duration_years = Math.round(duration_days / 365);

    let selected_duration = 0;
    let duration_type = "";

    switch (true) {
        case (duration_seconds <= 60):
            selected_duration = duration_seconds;
            duration_type = duration_seconds === 1 ? "second" : "seconds";
            break;
        case (duration_minutes <= 60):
            selected_duration = duration_minutes;
            duration_type = duration_minutes === 1 ? "minute" : "minutes";
            break;
        case (duration_hours <= 24):
            selected_duration = duration_hours;
            duration_type = duration_hours === 1 ? "hour" : "hours";
            break;
        case (duration_days <= 30):
            selected_duration = duration_days;
            duration_type = duration_days === 1 ? "day" : "days";
            break;
        case (duration_months <= 12):
            selected_duration = duration_months;
            duration_type = duration_months === 1 ? "month" : "months";
            break;
        case (duration_years >= 1):
            selected_duration = duration_years;
            duration_type = duration_years === 1 ? "year" : "years";
            break;
    }

    return { selected_duration, duration_type };
}

export default RemainingTime;